import Route from '@ember/routing/route';
import { service } from '@ember/service';

import { MainLayout } from 'register-partners-js/react/components/layouts/main';

export default class RegistrationPaymentRoute extends Route {
  mainLayout = MainLayout;

  @service checkout;
  @service intl;
  @service router;
  @service sentry;

  beforeModel() {
    if (this.modelFor('registration').isPaid) {
      this.router.transitionTo('registration.almost-ready');
    }
  }

  async model() {
    let registration = this.modelFor('registration');
    let organization = await registration.get('organization');

    let selectedProducts = await (async () => {
      try {
        return await this.checkout.fetchPricePlanSelectedTask.perform(organization.id);
      } catch {
        throw new Error('no price plan is selected');
      }
    })();

    let selectedPricePlan = selectedProducts.selected_products.find(
      ({ product_kind: kind }) => kind === 'core'
    );

    let estimation;
    let pricePlans;
    try {
      [estimation, pricePlans] = await Promise.all([
        this.checkout.fetchPriceEstimateForCompanyCreationTask.perform({
          legalCountry: selectedProducts.legal_country,
          productId: selectedPricePlan.product_id,
          recurrence: selectedPricePlan.recurrence,
        }),
        this.checkout.fetchPricePlansForCompanyCreationTask.perform({
          legalCountry: selectedProducts.legal_country,
          partnerName: registration.partnerName?.toLowerCase(),
        }),
      ]);
    } catch {
      // Trigger error page if the order is not found
      throw new Error('no order found');
    }

    let resolvedPricePlan = pricePlans.products.find(
      plan => plan.id === selectedPricePlan.product_id
    );

    return {
      estimation,
      organization,
      registration,
      selectedProducts,
      selectedPricePlan,
      resolvedPricePlan,
    };
  }

  redirect(model) {
    // Without the resolved plan we don't know what to charge, so the payment
    // would inevitably fail. Send the user to the error page instead of
    // rendering a payment form that can't complete.
    if (!model.resolvedPricePlan) {
      this.sentry.captureException(new Error('Selected price plan not found in catalog'), {
        extra: {
          organizationId: model.organization.id,
          productId: model.selectedPricePlan.product_id,
          legalCountry: model.selectedProducts.legal_country,
        },
      });
      return this.router.transitionTo('registration.payment-error');
    }
  }

  setupController(controller, model) {
    super.setupController(...arguments);

    controller.setProperties({
      model,
      registration: this.modelFor('registration'),
    });
  }

  activate() {
    // this sets an event for 'localeChanged' on which intl service
    // emits whenever locale is updated through 'setLocale'
    this.intl.onLocaleChanged(this.refresh, this);
  }
}
